// Component to be used for displaying the summary of a single CloudSystem
import * as React from 'react';

import { Box, Card, CardActionArea, Grid, Stack, Typography } from '@mui/material';
import { getCardStyling } from './CloudSystemCardHelpers';

// JS doesn't have interfaces
//  use this commented out definition as a reference for the props that should be accepted for this component 
// export interface CloudSystemCardProps {
//   onClick : func
//   cloudSystem : CloudSystem to load details for
//   cloudType : 'fbo' | 'cloudport' | 'uncommissioned'
// }


const CloudSystemCard = (props) => {

  const handleClick = (event) => {
    if (props.onClick) {
      props.onClick(props.cloudSystem?.serialNumber);
    } else {
      console.error("CloudSystemCard: No onClick handler prop defined");
    }
  };

  const cardStyling = getCardStyling(props.cloudSystem, props.cloudType);

  return (
    <>
        <Card
            raised={true}
            sx={{ 
              width: 327.8, 
              borderLeft: `5px solid ${cardStyling?.borderLeftColor}`, 
              backgroundColor: cardStyling?.backgroundColor,
              borderRadius: 0,
            }}
        > 
          <CardActionArea
            onClick={handleClick}
          >
            <Box 
              height={176}
            >
              <Box height={100} sx={{ padding: 1 }}>
                <Grid container direction={'row'}>
                  <Grid item>
                    <Typography variant="body2" fontSize={16} color={cardStyling.textColor}>
                      {props.cloudSystem?.serialNumber && props.cloudSystem?.serialNumber !== "" ? props.cloudSystem.serialNumber : "No Serial #"}
                    </Typography>
                  </Grid>
                  <Grid item alignContent={"center"} sx={{ ml: 'auto' }}>
                    <Stack direction="row"  display={"flex"} alignItems="center" justifyContent="center">
                      <Typography variant='caption' fontSize={16} color={cardStyling.secondaryTextColor} sx={{ mr: 1 }}>
                        {cardStyling.networkHealthText}
                      </Typography>
                      {cardStyling.networkHealthIcon}
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container direction={'row'}>
                  <Typography variant='caption' fontSize={16} color={cardStyling.secondaryTextColor}>
                    {props.cloudSystem?.shortName && props.cloudSystem?.shortName !== "" ? props.cloudSystem.shortName : 
                      props.cloudSystem?.customer && props.customer?.shortName !== "" ? props.cloudSystem.customer : 
                      "-- --"}
                  </Typography>
                </Grid>
                <Grid container direction={'row'} sx={{ marginTop: 2 }}>
                  <Grid item>
                    <Typography variant='caption' fontSize={16} color={cardStyling.secondaryTextColor}>
                      VPN Tunnel
                    </Typography>
                  </Grid>
                  <Grid item sx={{ marginLeft: 'auto' }}> 
                    <Typography variant='caption' fontSize={16} color={cardStyling.textColor}>
                      {props.cloudSystem?.vpnIP && props.cloudSystem?.vpnIP !== "" ? props.cloudSystem.vpnIP : "No IP"}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box height={76} display={"flex"} alignItems="center" justifyContent="center" sx={{ borderTop: '1px solid #AEB1B4', padding: 1 }}>
                <Grid container direction={'row'}>
                  <Grid item xs={4}>
                    <Box height={76} display="flex" alignItems="center" justifyContent="center">
                      <Stack display={'flex'} alignItems="center" justifyContent={'center'}>
                        <Stack direction="row" display="flex" alignItems={"center"} justifyContent={'center'}>
                          {cardStyling.aircraftIcon}
                          <Typography variant="h5" color={cardStyling.aircraftStatusColor}>
                            {props.cloudSystem?.uniqueACIDSWithinHealthyRange ?? 0}
                          </Typography>
                        </Stack>
                        <Typography variant='caption' fontSize={16} color={cardStyling.secondaryTextColor}>
                          Aircraft
                        </Typography>
                      </Stack>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box height={76} display="flex" alignItems="center" justifyContent="center">
                      <Stack display={'flex'} alignItems="center" justifyContent={'center'}>
                        {cardStyling.softwareIcon}
                        <Typography variant='caption' fontSize={16} color={cardStyling.secondaryTextColor}>
                          Software
                        </Typography>
                      </Stack>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box height={76} display="flex" alignItems="center" justifyContent="center">
                      <Stack display={'flex'} alignItems="center" justifyContent={'center'}>
                        {cardStyling.contentIcon}
                        <Typography variant='caption' fontSize={16} color={cardStyling.secondaryTextColor}>
                          Content
                        </Typography>
                      </Stack>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </CardActionArea>
        </Card>
    </>
  );
};

export default CloudSystemCard;